import React, {Component} from 'react'
import {Button} from "react-bootstrap";
import '../styles/Komunikat.css'
import AdminService from "../admin/adminComponents/AdminService";
import AppConfig from "../AppConfig";

export default class Komunikat extends Component {

    constructor(props) {
        super(props);

        this.state = {
            tresc: '',
            loading: true
        }

    }

    componentDidMount() {
        AdminService.getStronaById(93)
            .then(function (response) {
                this.setState({loading: false, tresc: response.data.tresc})
            }.bind(this)).catch(err => {
            console.log(err)
        })
    }

    render() {
        return <div className="komunikatWejscie">
            <div className="komunikat">
                <div className={'tresc'}>
                    <div dangerouslySetInnerHTML={{__html: "<h3 class='text-center'>Ta strona wykorzystuje pliki cookie</h3><br/>" +
                            "<p>" +
                            "<b>Drogi Użytkowniku</b>,</p>\n" +
                            "\n" +
                            "<p>Zachęcamy do zapoznania się z Polityką Prywatności w zakresie przetwarzania danych osobowych wprowadzoną w oparciu o przepisy Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r., w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE („RODO”), " +
                            "która znajduje się " +
                            "<a href=" + AppConfig.HOST_API() + 'client/api/plik/link/polityka-prywatnosci' + ">tutaj</a>." +
                            "</p>" +
                            "<p>Używamy informacji zapisanych za pomocą plików cookies w celu zapewnienia maksymalnej wygody w korzystaniu z naszego serwisu. Jeżeli wyrażasz zgodę na zapisywanie informacji zawartej w cookies kliknij przycisk &bdquo;<b>Przejdź do strony</b>&rdquo; znajdujący się na dole tej informacji. Jeśli nie wyrażasz zgody, ustawienia dotyczące plików cookies możesz zmienić w swojej przeglądarce.</p>"}}></div>
                </div>
                <div className="row" style={{marginTop: 25}}>
                    <div className="col-xl-7"/>
                    <div className="col-xl-5 text-right">
                        {/*<Button onClick={() => this.props.setKomunikat()}*/}
                        {/*        style={{background: '#eeb207', color: 'white'}}>Nie teraz</Button>*/}
                        <Button className={"pull-right"} onClick={() => this.props.setKomunikat()}
                                style={{background: '#8dc846', color: 'white'}}>Przejdź do strony</Button>
                    </div>
                </div>
            </div>
        </div>
    }


}



// WEBPACK FOOTER //
// ./src/components/shared/Komunikat.js